import { CSSProperties, ReactNode } from 'react'
import { useIntl } from 'react-intl'
import { Moment } from 'moment'

type DateFormat = 'relative' | 'duration' | string

const dateFormat = (date: Moment, format: DateFormat): string => {
  if (format === 'relative') {
    return date.fromNow()
  }

  if (format === 'duration') {
    return date.fromNow(true)
  }

  return date.format(format)
}

interface HumanDateProps {
  children?: (formattedDate: string) => ReactNode
  date: Moment
  format?: DateFormat
  style?: CSSProperties
}

const HumanDate = ({ children, date, format = 'relative', style }: HumanDateProps) => {
  const intl = useIntl()
  date.locale(intl?.locale)

  if (children && typeof children === 'function') {
    return <>{children(dateFormat(date, format))}</>
  }

  return <span style={style}>{dateFormat(date, format)}</span>
}

export default HumanDate
